import React, { Component } from 'react';

import Product from '../../Product/Product';

class Second extends Component {
  render() {
    return (
      <div className="collection-wrapper">
        <p className="Second-intro">Hello from <code>Second</code>.</p>
        <div className="Product-wrapper">
          { this.props.data.shop.products.edges.map(product =>
            <Product
              addVariantToCart={this.addVariantToCart}
              checkout={this.props.checkout}
              key={product.node.id.toString()}
              product={product.node}
            />
          )}
        </div>
      </div>
    );
  }
}

export default Second;



// WEBPACK FOOTER //
// ./src/components/Page/Second/Second.js